import { render } from "./FilestackS3.vue?vue&type=template&id=a4bfa310"
import script from "./FilestackS3.vue?vue&type=script&lang=js"
export * from "./FilestackS3.vue?vue&type=script&lang=js"

import "./FilestackS3.vue?vue&type=style&index=0&id=a4bfa310&lang=css"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__